// // import React, { useEffect, useRef } from 'react';
// // import { Link } from 'react-router-dom';
// // import { motion, useAnimation, useInView } from 'framer-motion';

// // export default function BlogNews() {
// //   const headerRef = useRef(null);
// //   const cardsRef = useRef(null);

// //   const headerControls = useAnimation();
// //   const cardsControls = useAnimation();

// //   const headerInView = useInView(headerRef, { once: true, threshold: 0.3 });
// //   const cardsInView = useInView(cardsRef, { once: true, threshold: 0.2 });

// //   useEffect(() => {
// //     if (headerInView) {
// //       headerControls.start('visible');
// //     }
// //   }, [headerControls, headerInView]);

// //   useEffect(() => {
// //     if (cardsInView) {
// //       cardsControls.start('visible');
// //     }
// //   }, [cardsControls, cardsInView]);

// //   const headerVariants = {
// //     hidden: { opacity: 0, y: -20 },
// //     visible: {
// //       opacity: 1,
// //       y: 0,
// //       transition: {
// //         duration: 0.6,
// //         ease: 'easeOut',
// //       },
// //     },
// //   };

// //   const cardContainerVariants = {
// //     hidden: { opacity: 0 },
// //     visible: {
// //       opacity: 1,
// //       transition: {
// //         duration: 0.6,
// //         staggerChildren: 0.2,
// //       },
// //     },
// //   };

// //   const cardVariants = {
// //     hidden: { opacity: 0, y: 30 },
// //     visible: {
// //       opacity: 1,
// //       y: 0,
// //       transition: {
// //         duration: 0.5,
// //         ease: 'easeOut',
// //       },
// //     },
// //   };

// //   return (
// //     <section className="blognews mt-10">
// //       <div className="py-10 lg:py-14">
// //         <motion.h1
// //           ref={headerRef}
// //           className="lg-max-w-4xl md-max-w-2xl text-3xl lg:text-5xl text-center text-text-color tracking-normal font-medium"
// //           initial="hidden"
// //           animate={headerControls}
// //           variants={headerVariants}
// //         >
// //           Read about some of our
// //           <br />
// //           <span className="font-serif italic text-primary font-bold">
// //             work and stories
// //           </span>
// //         </motion.h1>

// //         <motion.div
// //           ref={cardsRef}
// //           className="news flex pt-8 px-6 lg:px-0 lg:gap-x-4 flex-col lg:flex-row align-center justify-center"
// //           initial="hidden"
// //           animate={cardsControls}
// //           variants={cardContainerVariants}
// //         >
// //           <motion.div
// //             className="blog-lg w-full h-auto lg:w-[700px] lg:h-[455px] bg-cover bg-no-repeat"
// //             style={{
// //               backgroundImage: `linear-gradient(to bottom, rgba(97, 97, 97, 0.3) 30%, rgba(0, 0, 0, 0.9) 90%), url('https://blog.shecluded.com/wp-content/uploads/2025/03/Shecluded-Gold-banner-1.png')`,
// //             }}
// //             variants={cardVariants}
// //           >
// //             <div className="blog-lg-content pb-6 mt-48 lg:mt-64 px-6">
// //               <h1 className="text-white font-medium text-3xl">
// //                 Nigeria to Roll Out WE-Elevate, Accelerating Digital Inclusion
// //                 for Female Entrepreneurs
// //               </h1>
// //               <div className="blog-date flex flex-row text-light-grey-2 text-base pt-4 pb-4">
// //                 <p>Read</p>
// //                 <p className="px-2">|</p>
// //                 <p className="">September 29, 2025</p>
// //               </div>
// //               <Link
// //                 to="https://blog.shecluded.com/shecluded-launches-gold-to-bridge-the-growth-gap-for-women-entrepreneurs/"
// //                 className="text-lg font-semibold leading-10 underline-offset-4 tracking-normal text-white underline"
// //               >
// //                 Learn more
// //               </Link>
// //             </div>
// //           </motion.div>
// //           <motion.div
// //             className="blog-sm flex flex-col mt-4 lg:mt-0"
// //             variants={cardContainerVariants}
// //           >
// //             <Link to="https://blog.shecluded.com/alx-and-shecludeds-bold-initiative-for-financial-empowerment/">
// //               <motion.div
// //                 className="blog-sm-content flex flex-col lg:flex-row gap-y-4 lg:gap-y-0"
// //                 variants={cardVariants}
// //               >
// //                 <img
// //                   src="https://blog.shecluded.com/wp-content/uploads/2025/02/IMG_2192-scaled.jpg"
// //                   className="w-full h-auto lg:w-[200px] lg:h-[130px] object-cover"
// //                   alt="women at a shecluded event"
// //                 />
// //                 <div className="blog-details text-dark-grey-2 pt-0 lg:pl-2">
// //                   <p className="text-sm lg:text-base font-medium">SPOTLIGHT</p>
// //                   <h1 className="text-text-color font-semibold text-base lg:text-base uppercase pt-2">
// //                     Shecluded Partners with FHSA to <br /> Implement the ANTFem
// //                     Program,
// //                     <br /> Empowering 133 Women Across Five <br /> Nigerian
// //                     States
// //                   </h1>
// //                   <div className="blog-date flex flex-row text-dark-grey-2 text-sm lg:text-base pt-2">
// //                     <p>Read</p>
// //                     <p className="px-2">|</p>
// //                     <p className="">February 25, 2025</p>
// //                   </div>
// //                 </div>
// //               </motion.div>
// //             </Link>

// //             <Link
// //               to="https://blog.shecluded.com/what-weve-learned-from-supporting-50000-women-entrepreneurs-acrossnigeria/"
// //               className="py-6"
// //             >
// //               <motion.div
// //                 className="blog-sm-content flex flex-col lg:flex-row gap-y-4 lg:gap-y-0"
// //                 variants={cardVariants}
// //               >
// //                 <img
// //                   src="https://blog.shecluded.com/wp-content/uploads/2025/02/Shecluded-Milestone-2025-scaled.jpg"
// //                   className="w-full h-auto lg:w-[200px] lg:h-[130px] object-cover"
// //                   alt="women at a shecluded event"
// //                 />
// //                 <div className="blog-details text-dark-grey-2 pt-0 lg:pl-2">
// //                   <p className="text-sm lg:text-base font-medium">
// //                     SHECLUDEDNEWS
// //                   </p>
// //                   <h1 className="text-text-color font-semibold text-base lg:text-base uppercase pt-2">
// //                     What We’ve Learned from
// //                     <br /> Supporting 50,000 Women
// //                     <br /> Entrepreneurs across Nigeria
// //                   </h1>
// //                   <div className="blog-date flex flex-row text-dark-grey-2 text-sm lg:text-base pt-2">
// //                     <p>Read</p>
// //                     <p className="px-2">|</p>
// //                     <p className="">February 10, 2025</p>
// //                   </div>
// //                 </div>
// //               </motion.div>
// //             </Link>

// //             <Link to="https://blog.shecluded.com/the-making-of-afrikayla-how-ibijoke-oyindamola-shallangwa-is-styling-the-stars/">
// //               <motion.div
// //                 className="blog-sm-content flex flex-col lg:flex-row gap-y-4 lg:gap-y-0"
// //                 variants={cardVariants}
// //               >
// //                 <img
// //                   src="https://blog.shecluded.com/wp-content/uploads/2025/02/Ibijoke-Oyindamola-Shallangwa-1.jpg"
// //                   className="w-full h-auto lg:w-[200px] lg:h-[130px] object-cover"
// //                   alt="women at a shecluded event"
// //                 />
// //                 <div className="blog-details text-dark-grey-2 lg:pt-2 lg:pl-2">
// //                   <p className="text-sm lg:text-base font-medium">
// //                     SHECLUDEDNEWS
// //                   </p>
// //                   <h1 className="text-text-color font-semibold text-md lg:text-base uppercase pt-1">
// //                     The Making of Afrikayla How <br />
// //                     Ibijoke Oyindamola Shallangwa
// //                     <br /> is Styling the Stars
// //                   </h1>
// //                   <div className="blog-date flex flex-row text-dark-grey-2 text-sm lg:text-base pt-1">
// //                     <p>Read</p>
// //                     <p className="px-2">|</p>
// //                     <p className="">February 7, 2025</p>
// //                   </div>
// //                 </div>
// //               </motion.div>
// //             </Link>
// //           </motion.div>
// //         </motion.div>
// //       </div>
// //     </section>
// //   );
// // }

// import React, { useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { motion, useAnimation, useInView } from 'framer-motion';

// export default function BlogNews() {
//   const headerRef = useRef(null);
//   const cardsRef = useRef(null);

//   const headerControls = useAnimation();
//   const cardsControls = useAnimation();

//   const headerInView = useInView(headerRef, { once: true, threshold: 0.3 });
//   const cardsInView = useInView(cardsRef, { once: true, threshold: 0.2 });

//   useEffect(() => {
//     if (headerInView) headerControls.start('visible');
//   }, [headerControls, headerInView]);

//   useEffect(() => {
//     if (cardsInView) cardsControls.start('visible');
//   }, [cardsControls, cardsInView]);

//   const headerVariants = {
//     hidden: { opacity: 0, y: -20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.6, ease: 'easeOut' },
//     },
//   };

//   const cardContainerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: { duration: 0.6, staggerChildren: 0.2 },
//     },
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 30 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.5, ease: 'easeOut' },
//     },
//   };

//   return (
//     <section className="blognews mt-10">
//       <div className="py-10 lg:py-14">
//         {/* HEADER */}
//         <motion.h1
//           ref={headerRef}
//           className="max-w-4xl mx-auto text-3xl lg:text-5xl text-center text-text-color tracking-normal font-medium"
//           initial="hidden"
//           animate={headerControls}
//           variants={headerVariants}
//         >
//           Read about some of our
//           <br />
//           <span className="font-serif italic text-primary font-bold">
//             work and stories
//           </span>
//         </motion.h1>

//         {/* BLOG CARDS */}
//         <motion.div
//           ref={cardsRef}
//           className="news flex flex-col lg:flex-row justify-center gap-6 pt-8 px-6 lg:px-0"
//           initial="hidden"
//           animate={cardsControls}
//           variants={cardContainerVariants}
//         >
//           {/* MAIN LARGE CARD */}
//           <motion.div
//             className="w-full lg:w-[700px] bg-cover bg-no-repeat rounded-xl overflow-hidden flex-shrink-0 h-[480px]"
//             style={{
//               backgroundImage:
//                 "linear-gradient(to bottom, rgba(97, 97, 97, 0.3) 30%, rgba(0, 0, 0, 0.9) 90%), url('https://blog.shecluded.com/wp-content/uploads/2025/03/Shecluded-Gold-banner-1.png')",
//             }}
//             variants={cardVariants}
//           >
//             <div className="flex flex-col justify-end h-full p-6">
//               <h1 className="text-white font-medium text-2xl lg:text-3xl leading-snug">
//                 Nigeria to Roll Out WE-Elevate, Accelerating Digital Inclusion
//                 for Female Entrepreneurs
//               </h1>
//               <div className="flex items-center text-light-grey-2 text-sm pt-3">
//                 <p>Read</p>
//                 <p className="px-2">|</p>
//                 <p>September 29, 2025</p>
//               </div>
//               <Link
//                 to="https://blog.shecluded.com/shecluded-launches-gold-to-bridge-the-growth-gap-for-women-entrepreneurs/"
//                 className="text-white text-lg font-semibold underline underline-offset-4 pt-2"
//               >
//                 Learn more
//               </Link>
//             </div>
//           </motion.div>

//           {/* SIDE SMALL BLOGS */}
//           <motion.div
//             className="flex flex-col justify-between w-full lg:w-[400px] h-[480px]"
//             variants={cardContainerVariants}
//           >
//             {[
//               {
//                 title:
//                   'Shecluded Partners with FHSA to Implement the ANTFem Program, Empowering 133 Women Across Five Nigerian States',
//                 tag: 'SPOTLIGHT',
//                 date: 'February 25, 2025',
//                 image:
//                   'https://blog.shecluded.com/wp-content/uploads/2025/02/IMG_2192-scaled.jpg',
//                 link: 'https://blog.shecluded.com/alx-and-shecludeds-bold-initiative-for-financial-empowerment/',
//               },
//               {
//                 title:
//                   'What We’ve Learned from Supporting 50,000 Women Entrepreneurs across Nigeria',
//                 tag: 'SHECLUDEDNEWS',
//                 date: 'February 10, 2025',
//                 image:
//                   'https://blog.shecluded.com/wp-content/uploads/2025/02/Shecluded-Milestone-2025-scaled.jpg',
//                 link: 'https://blog.shecluded.com/what-weve-learned-from-supporting-50000-women-entrepreneurs-acrossnigeria/',
//               },
//               {
//                 title:
//                   'The Making of Afrikayla: How Ibijoke Oyindamola Shallangwa is Styling the Stars',
//                 tag: 'SHECLUDEDNEWS',
//                 date: 'February 7, 2025',
//                 image:
//                   'https://blog.shecluded.com/wp-content/uploads/2025/02/Ibijoke-Oyindamola-Shallangwa-1.jpg',
//                 link: 'https://blog.shecluded.com/the-making-of-afrikayla-how-ibijoke-oyindamola-shallangwa-is-styling-the-stars/',
//               },
//             ].map((post, index) => (
//               <Link to={post.link} key={index}>
//                 <motion.div
//                   className="flex flex-col lg:flex-row gap-4 items-start h-[31%]" // evenly divide height (3 cards)
//                   variants={cardVariants}
//                 >
//                   <img
//                     src={post.image}
//                     alt={post.title}
//                     className="w-full lg:w-[180px] h-[130px] object-cover rounded-md"
//                   />
//                   <div className="text-dark-grey-2 flex flex-col justify-between">
//                     <div>
//                       <p className="text-sm font-medium">{post.tag}</p>
//                       <h2 className="text-text-color font-semibold text-base mt-1 leading-snug line-clamp-3">
//                         {post.title}
//                       </h2>
//                     </div>
//                     <div className="flex items-center text-dark-grey-2 text-sm pt-2">
//                       <p>Read</p>
//                       <p className="px-2">|</p>
//                       <p>{post.date}</p>
//                     </div>
//                   </div>
//                 </motion.div>
//               </Link>
//             ))}
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useAnimation, useInView } from 'framer-motion';

export default function BlogNews() {
  const headerRef = useRef(null);
  const cardsRef = useRef(null);

  const headerControls = useAnimation();
  const cardsControls = useAnimation();

  const headerInView = useInView(headerRef, { once: true, threshold: 0.3 });
  const cardsInView = useInView(cardsRef, { once: true, threshold: 0.2 });

  useEffect(() => {
    if (headerInView) headerControls.start('visible');
  }, [headerControls, headerInView]);

  useEffect(() => {
    if (cardsInView) cardsControls.start('visible');
  }, [cardsControls, cardsInView]);

  const headerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const cardContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, staggerChildren: 0.2 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  return (
    <section className="blognews mt-10">
      <div className="py-10 lg:py-14">
        {/* HEADER */}
        <motion.h1
          ref={headerRef}
          className="max-w-4xl mx-auto text-3xl lg:text-5xl text-center text-text-color tracking-normal font-medium"
          initial="hidden"
          animate={headerControls}
          variants={headerVariants}
        >
          Read about some of our
          <br />
          <span className="font-serif italic text-primary font-bold">
            work and stories
          </span>
        </motion.h1>

        {/* BLOG CARDS */}
        <motion.div
          ref={cardsRef}
          className="news flex flex-col lg:flex-row justify-center gap-6 pt-8 px-6 lg:px-0"
          initial="hidden"
          animate={cardsControls}
          variants={cardContainerVariants}
        >
          {/* MAIN LARGE CARD */}
          <motion.div
            className="w-full lg:w-[700px] bg-cover bg-no-repeat rounded-xl overflow-hidden flex-shrink-0 h-[480px]"
            style={{
              backgroundImage:
                "linear-gradient(to bottom, rgba(97, 97, 97, 0.3) 30%, rgba(0, 0, 0, 0.9) 90%), url('https://shecluded-medias.s3.us-east-2.amazonaws.com/WE-Elevate.png')",
            }}
            variants={cardVariants}
          >
            <div className="flex flex-col justify-end h-full p-6">
              <h1 className="text-white font-medium text-2xl lg:text-3xl leading-snug">
                Nigeria to Roll Out WE-Elevate, Accelerating Digital Inclusion
                for Female Entrepreneurs
              </h1>
              <div className="flex items-center text-light-grey-2 text-sm pt-3">
                <p>Read</p>
                <p className="px-2">|</p>
                <p>September 29, 2025</p>
              </div>
              <Link
                to="https://blog.shecluded.com/nigeria-to-roll-out-we-elevate-accelerating-digital-inclusion-for-female-entrepreneurs/"
                className="text-white text-lg font-semibold underline underline-offset-4 pt-2"
              >
                Learn more
              </Link>
            </div>
          </motion.div>

          {/* SIDE SMALL BLOGS */}
          <motion.div
            className="flex flex-col justify-between w-full lg:w-[400px] h-[480px]"
            variants={cardContainerVariants}
          >
            {[
              {
                title:
                  'Shecluded Partners with FHSA to Implement the ANTFem Program, Empowering 133 Women Across Five Nigerian States',
                tag: 'SPOTLIGHT',
                date: 'February 25, 2025',
                image:
                  'https://shecluded-medias.s3.us-east-2.amazonaws.com/Shecluded+Partners+with+FHSA2.jpg',
                link: 'https://blog.shecluded.com/shecluded-partners-with-fhsa-to-implement-the-antfem-program-empowering-133-women-across-five-nigerian-states/',
              },
              {
                title: 'Why We Bet on Women and What Happens When They WIN',
                tag: 'SHECLUDEDNEWS',
                date: 'July 21, 2025',
                image:
                  'https://shecluded-medias.s3.us-east-2.amazonaws.com/Why-We-Bet-on-Women.png',
                link: 'https://blog.shecluded.com/why-we-bet-on-women-and-what-happens-when-they-win/',
              },
              {
                title:
                  'Retail Visionary, Grant Winner, and Champion for Small Businesses',
                tag: 'SHECLUDEDNEWS',
                date: 'April 25, 2025',
                image:
                  'https://shecluded-medias.s3.us-east-2.amazonaws.com/retail-visionary.png',
                link: 'https://blog.shecluded.com/retail-visionary-grant-winner-and-champion-for-small-businesses/',
              },
            ].map((post, index) => (
              <Link to={post.link} key={index}>
                <motion.div
                  className="flex flex-col lg:flex-row gap-2 items-start h-[31%]" // evenly divide height (3 cards)
                  variants={cardVariants}
                >
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full lg:w-[180px] h-[130px] object-cover rounded-md mt-10 lg:mt-0"
                  />
                  <div className="text-dark-grey-2 flex flex-col justify-between">
                    <div>
                      <p className="text-sm font-medium">{post.tag}</p>
                      <h2 className="text-text-color font-semibold text-base mt-1 leading-snug">
                        {post.title}
                      </h2>
                    </div>
                    <div className="flex items-center text-dark-grey-2 text-sm pt-2">
                      <p>Read</p>
                      <p className="px-2">|</p>
                      <p>{post.date}</p>
                    </div>
                  </div>
                </motion.div>
              </Link>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
